<template>
    <div>
        <el-form :model="chargeItemInfo" :rules="chargeItemRules" ref="chargeItemInfo">
            <div class="column-layout flex">
                <div class="form-info">
                    <div class="form-row">
                        <div class="form-label">
                            <label class="required">服务类型</label>
                        </div>
                        <div class="form-value width-1-5x">
                            <el-form-item prop="servcTypeId">
                                <el-select v-model="chargeItemInfo.servcTypeId" :disabled="initServcTypeId != null">
                                    <el-option v-for="valueType in servcTypeList" :value="valueType.value" :label="valueType.text"></el-option>
                                </el-select>
                            </el-form-item>
                        </div>
                    </div>
                </div>
            </div>
            <div class="content-caption dashed bg-white required">
                <span>收费项</span>
            </div>
            <table class="custom-tbl">
                <thead class="head">
                <tr class="row">
                    <th style="text-align: left">名称</th>
                    <th width="150">参考价格</th>
                    <th width="80">操作</th>
                </tr>
                </thead>
                <tbody class="body">
                <tr v-if="subChargeItemList != null && subChargeItemList.length > 0" v-for="(item,index) in subChargeItemList" class="row">
                    <td style="text-align: left">
                        <el-input v-model="item.name"></el-input>
                    </td>
                    <td>
                        <el-input type="number" v-model="item.price"></el-input>
                    </td>
                    <td>
                        <span class="swb-btn swb-btn-link" @click="removeInfo(index)">移除</span>
                    </td>
                </tr>
                <tr class="row">
                    <td colspan="3" style="text-align: center; line-height: 40px;">
                        <span class="swb-btn swb-btn-link" @click="addInfo()">添加</span>
                    </td>
                </tr>
                </tbody>
            </table>
        </el-form>
    </div>
</template>

<script>

    import { Utils } from '../../app.base'
    import { Vue } from '../../app.vues'
    import { openMerchtFusedServcCategSelectDlg } from '../categ/selectDlg'

    import servcOperApi from '../../api/servcOper'

    import SwbServcCategTree from './ServcCategTree';
    Vue.regist(SwbServcCategTree);

    export default {
        name: 'swb-servc-type-charge-item-save-batch',
        props: ['initServcTypeId'],
        desc: '服务批量设置参考价格',
        data: function () {
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不可为空'));
                } else {
                    callback();
                }
            };
            return {
                servcTypeList: getEnumList("servcType"),
                chargeItemInfo: {
                    servcTypeId: getEnumInfoWith('servcType', 'name', 'Product').value
                },
                subChargeItemList: [],
                chargeItemRules: {
                    servcTypeId: [{validator: checkNull, trigger: 'blur'}],
                }
            }
        },
        created(){
            if(!Utils.isNoB(this.initServcTypeId)) {
                this.chargeItemInfo.servcTypeId = this.initServcTypeId;
            }
        },
        methods: {
            addInfo: function () {
                let subChargeItemList = this.subChargeItemList || [];
                subChargeItemList.push({name: null, price: 0});
                //
                this.subChargeItemList = Utils.merge([], subChargeItemList);
            },
            removeInfo: function (index) {
                let subChargeItemList = this.subChargeItemList || [];
                subChargeItemList.splice(index, 1);
                //
                this.subChargeItemList = Utils.merge([], subChargeItemList);
            },
            getDlgResult: function () {
                let self = this;
                let result = {
                    type: 'info'
                };
                this.$refs['chargeItemInfo'].validate(function (valid) {
                    if(valid) {
                        let subChargeItemList = self.subChargeItemList || [];
                        if(subChargeItemList.length <= 0) {
                            result.type = "warn";
                            result.message = "请添加收费项";
                        } else {
                            let message = null;
                            for(let i = 0; i < subChargeItemList.length; i++) {
                                if(Utils.isNoB(subChargeItemList[i].name)) {
                                    message = "名称不可为空";
                                    break;
                                }
                                if(Utils.isNoB(subChargeItemList[i].price)) {
                                    message = subChargeItemList[i].name + "：参考价格不可为空";
                                    break;
                                } else if(!Utils.isMoneyStr(subChargeItemList[i].price)) {
                                    message = subChargeItemList[i].name + "：请输入正确的金额";
                                    break;
                                }
                            }
                            if(!Utils.isNoB(message)) {
                                result.type = "warn";
                                result.message = message;
                            } else {
                                let chargeItemInfo = self.chargeItemInfo || {};
                                chargeItemInfo.subChargeItemList = subChargeItemList;
                                //
                                result.data = chargeItemInfo;
                            }
                        }
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            },
        },
    }
</script>




// WEBPACK FOOTER //
// src/compo/categ/ServcTypeChargeItemListSave.vue